import { useTranslation } from "react-i18next";
import { ErrorState as BaseErrorState } from "@tabipla/ui";
import { getErrorMessage } from "@tabipla/shared";

export interface ErrorStateProps {
  error?: Error | string | null;
  onRetry?: () => void;
  className?: string;
}

/**
 * ErrorState wrapper that provides i18n translations.
 * Uses @tabipla/ui's ErrorState internally.
 */
export function ErrorState({ error, onRetry, className }: ErrorStateProps) {
  const { t } = useTranslation();

  // Handle string errors directly, otherwise use shared utility
  const translatedMessage = typeof error === "string" ? error : getErrorMessage(error, t);

  return (
    <BaseErrorState
      error={translatedMessage}
      onRetry={onRetry}
      className={className}
      title={t("error.somethingWentWrong")}
      retryLabel={t("error.tryAgain")}
    />
  );
}
